<template>
  <div class="ar-2-1 animate__animated animate__fadeIn">
    <div class="widget-7 card bg-white no-margin widget-loader-bar">
      <div class="card-header top-left top-right">
        <div class="text-black hint-text h6">
          <span>{{ card_title }} </span>
        </div>
      </div>
      <div class="card-body p-t-40">
        <div class="row">
          <div class="col-sm-12">
            <h4
              class="no-margin p-b-5 semi-bold"
              :class="[`text-${number_color}`]"
              :title="thousand_separator(card_content)"
            >
              <i :class="card_icon">{{ icon_name }}</i>
              {{ kmb_formatter(card_content) }}
              <span class="fs-12" v-if="dalam_kurung">
                ({{ dalam_kurung }})
              </span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import general_plugin from "@/plugins/generalPlugins.js";
export default {
  name: "card_dynamic",
  props: {
    card_title: {
      type: String,
      description: "Card title",
    },
    card_content: {
      type: String,
      description: "Card content",
    },
    number_color: {
      type: String,
      description: "Number text color",
    },
    card_icon: {
      type: String,
      description: "Number text color",
    },
    card_color: {
      type: String,
      description: "Number text color",
    },
    icon_name: {
      type: String,
      default: "",
    },
    dalam_kurung: String,
  },
  methods: {
    thousand_separator: function (str) {
      return general_plugin.thousandSeparator(str);
    },
    kmb_formatter: function (str) {
      return general_plugin.kmbFormatter(str);
    },
  },
};
</script>

<style scoped="">
.text-purple {
  color: #6f42c1 !important;
}
.text-orange {
  color: #fd7e14 !important;
}
.text-teal {
  color: #28a745 !important;
}
.text-pink {
  color: #e83e8c !important;
}
.text-cyan {
  color: #17a2b8 !important;
}
.text-pink {
  color: #e83e8c !important;
}
.pg-icon {
  font-size: 25px;
}
</style>